<template>
  <div class="row">
     <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="card m-b-30">
           <div class="card-header">
               <h5 class="card-title">Mi Carrito de Compras</h5>
            </div>
            <div class="card-body">

               <div class="row" v-if="!hasItems">
                  <div class="col-12 col-lg-10">
                     <h6>Actualmente no tienes productos en tu carrito de compras.</h6>
                     <button type="button" class="btn btn-primary-rgba mt-3 mb-1" @click.stop="goToShopping" >
                        <i class="feather icon-shopping-bag mr-2"></i>Ir a comprar
                     </button>
                  </div>
               </div>

               <div class="row justify-content-center" v-if="hasItems">
                  <div class="col-12 col-lg-10">
                     <div class="cart-container border-mid">
                        <div class="cart-head">
                           <h6>Lista de productos agregados</h6>
                           <div class="table-responsive" v-if="hasProducts">
                              <table class="table table-borderless">
                                 <thead>
                                    <tr>
                                       <th scope="col">Acciones</th>
                                       <th scope="col">#</th>
                                       <!--<th scope="col"></th>-->
                                       <th scope="col">Producto</th>
                                       <th scope="col">Piezas</th>
                                       <!--<th scope="col">Subtotal</th>-->
                                       <th scope="col" class="text-right">Total</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr v-for="(det, idx) in order_details" :key="idx">
                                       <td>
                                          <a class="text-danger cursor-pointer mr-4 font-20" @click.stop="deleteProductRequest(det.product_id)"><i class="feather icon-trash"></i></a>
                                          <a class="text-info cursor-pointer font-20" @click.stop="editProductRequest(det.product_id)"><i class="feather icon-edit"></i></a>
                                       </td>
                                       <th scope="row">{{det.product.code}}</th>
                                       <!--<td><img :src="getProductImgUrl(det.product)" class="img-fluid rounded-circle" width="35" alt="product"></td>-->
                                       <td>{{det.product.name}}</td>
                                       <td>{{det.pieces}}</td>
                                       <!--<td>{{explicitMoneyFormat(det.subtotal)}}</td>-->
                                       <td class="text-right">{{explicitMoneyFormat(det.cost)}}</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>

                           <div v-if="hasPromos">
                              <hr>
                              <h6>Lista de promociones agregadas</h6>
                              <div class="table-responsive">
                                 <table class="table table-borderless">
                                    <thead>
                                       <tr>
                                          <th scope="col">Acciones</th>
                                          <th scope="col">Nombre</th>
                                          <th scope="col">Cantidad</th>
                                          <th scope="col">Total</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       <tr v-for="(det, idx) in promotion_details" :key="idx">
                                          <td><a class="text-danger cursor-pointer" @click.stop="deletePromoRequest(det.promotion_id)"><i class="feather icon-trash"></i></a></td>
                                          <td>{{det.promotion.name}}</td>
                                          <td>{{det.quantity}}</td>
                                          <td>{{explicitMoneyFormat(det.total)}}</td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </div>


                        </div>
                        <div class="cart-body">
                           <div class="row">
                              <div class="col-md-12 order-2 order-lg-1 col-lg-5 col-xl-6">
                                 <div class="order-note">
                                    <form>
                                       <!--
                                       <div class="form-group">
                                          <div class="input-group">
                                             <input type="search" class="form-control form-control" placeholder="Código" aria-label="Search" aria-describedby="button-addonTags">
                                             <div class="input-group-append">
                                                   <button class="input-group-text" type="submit" id="button-addonTags">Aplicar</button>
                                             </div>
                                          </div>
                                       </div>
                                       -->
                                       <div class="form-group">
                                          <label for="specialNotes">Nota especial para esta orden:</label>
                                          <textarea class="form-control form-control-mid" v-model="notas_orden" name="specialNotes" id="specialNotes" rows="3" placeholder="Ingrese mensaje"></textarea>
                                       </div>
                                    </form>
                                 </div>
                              </div>
                              <div class="col-md-12 order-1 order-lg-2 col-lg-7 col-xl-6">
                                 <div class="order-total table-responsive ">
                                    <table class="table table-borderless text-right">
                                       <tbody>
                                         <!--  <tr>
                                             <td>Subtotal: </td>
                                             <td>{{explicitMoneyFormat(subtotal)}}</td>
                                          </tr> -->
                                          <tr>
                                             <td>IVA: </td>
                                             <td>{{explicitMoneyFormat(ivaOrder)}}</td>
                                          </tr>
                                           <tr>
                                             <td>IEPS: </td>
                                             <td>{{explicitMoneyFormat(ipsOrder)}}</td>
                                          </tr>
                                          <tr>
                                             <td>Descuentos: </td>
                                             <td>{{explicitMoneyFormat(totalDescuentosOrden)}}</td>
                                          </tr>
                                          <tr>
                                             <td class="f-w-7 font-18"><h4>Total:</h4></td>
                                             <td class="f-w-7 font-18"><h4>{{explicitMoneyFormat(totalImportePagar)}}</h4></td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="cart-footer text-right">
                           <button type="button" class="btn btn-primary-rgba my-1 mr-2" @click.stop="goToShopping" ><i class="feather icon-shopping-bag mr-2"></i>Continuar comprando</button>
                           <!--<router-link :to="{name: 'checkout'}" class="btn btn-success-rgba my-1 ml-2" @click.stop="goToShopping" >Proceder al pago<i class="feather icon-arrow-right ml-2"></i></router-link>-->
                           <button class="btn btn-success-rgba my-1 ml-2" @click.stop="goToCheckout" >Confirmar productos<i class="feather icon-arrow-right ml-2"></i></button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
        </div>
     </div>

     <product-prompt
         :product="currentProduct"
         :initial-pieces="initialPieces"
         :on-edit-mode="true"
         :showSaveAndContinueBtn="true"
         :showSaveAndActionBtn="false"
         saveAndContinueBtnUpdateText="Actualizar cantidad del producto"
         @on-save-product-and-continue="onUpdateProduct" />

  </div>
</template>

<script>
import {mapState, mapMutations, mapGetters} from "vuex";
import formatHelper from "@mixins/formatHelper"
import cartHelper from "@mixins/cartHelper"
import ProductPrompt from "@components/clients/ProductPrompt.vue"
import {Product} from "../../classes/product"
import {Client_Info} from "../../classes/client_info"
import {Descuento_Monto} from "../../classes/descuento_monto"
import {SpecialPriceProduct} from "../../classes/special_price_product"
export default {
   name: "CartPage",
   mixins: [formatHelper, cartHelper],
   components: { ProductPrompt },
   data(){
      return {
         thumbnailUrl: "https://i.ibb.co/TcVZypR/mini-product.png",
         currentProductId: null,
         currentPromoId: null,
         clientInfo: null,
         specialPriceProducts: [],
         notas_orden: null,
         totalProductos: null,
         totalPiezasProductos: null,
         totalCajasProductos: null,
         totalDescuentoProductos: null,
         totalProductosPromociones: null,
         totalDescuentoPromos: null,
         // Configuración de descuentos por monto de piezas, cajas e importes         
         usandoDescuentoMonto: false,
         totalDescuentosxMonto: null,
         descuentosPorMonto: [],
         descuentoMontoAlcanzado: null,
         descuentoMontoAlcanzadoAux: null,
         segmentosNoAplicaList: [],
         aplicaDescuentoCliente: false,
         descuentoClientePg: null,
         descuentoMontoAlcanzadoPg: null,
         // Montos de orden
         totalDescuentosOrden: null,
         totalImportePagar: null,
         currentProduct: null,
         initialPieces: 0,
         subtotal: 0,
      }
   },
   async mounted(){
      await this.getClientInfo();
      await this.getOrderDiscounts();
   },
   computed: {
      ...mapState("cart", ["order_notes", "order_details", "promotion_details", "amounts", "promo_amounts"]),
      ...mapState("auth", ["user"]),
      ...mapGetters("general", ["getDiscountBeer", "getDiscountsbyAmount", "getSpecialPriceProducts"]),
      hasItems(){
         return this.hasProducts || this.hasPromos
      },
      hasProducts(){
         return (this.order_details && this.order_details.length > 0)
      },
      hasPromos(){
         return (this.promotion_details && this.promotion_details.length > 0)
      },
      ivaOrder(){

        var totalIVA = 0
        var totalIVAOrders = 0
        var totalIVAPromos = 0
        
        this.order_details.forEach(odt => {
            totalIVAOrders+= odt.iva
        });

        this.promotion_details.forEach(pdt => {
          pdt.order_details.forEach(odt => {
            totalIVAPromos+= odt.iva
          });
        });
        totalIVA = totalIVAOrders + totalIVAPromos
        return totalIVA
      },
      ipsOrder(){
         var totalIEPS = 0
         var totalIEPSOrders = 0
         var totalIEPSPromos = 0

         this.order_details.forEach(odt => {
            totalIEPSOrders+= odt.ieps
         });

         this.promotion_details.forEach(pdt => {
           pdt.order_details.forEach(odt => {
             totalIEPSPromos+= odt.ieps
           });
         });
         totalIEPS = totalIEPSOrders + totalIEPSPromos
         return totalIEPS  
      },
   },
   methods: {
      ...mapMutations("cart", ["addOrUpdateOrderDetail", "updateAmounts", "updatePromoAmounts"]),
      ...mapMutations("cart", ["removeOrderDetailForProduct", "removePromotionDetailForPromo"]),
      ...mapMutations("cart", ["setOrderNotes"]),
      async goToShopping(){
         await this.$router.push({name: "cliente-comprar"})
      },
      async goToCheckout(){
         this.setOrderNotes(this.notas_orden)
         await this.$router.push({name: "checkout"})
      },
      deleteProductRequest(id){
         this.currentProductId = id;
         let mssg = "¿Desea quitar el producto de su carrito?";
         this.confirmationDialog(this.doDeleteProduct, "Confirmar", mssg, "Eliminar");
      },
      doDeleteProduct(){
         this.removeOrderDetailForProduct(this.currentProductId)
         const amounts = this.calculateTotalAmounts(this.order_details)
         this.updateAmounts(amounts);
         this.loadDiscountsOrder()
         //this.updateSaleInfo()
      },
      editProductRequest(id) {
         this.currentProductId = id;
         let existing = this.order_details.find(f => f.product_id === id)
         this.initialPieces = (existing ? parseInt(existing.pieces) : 1)
         this.currentProduct = existing.product
         this.openProductPrompt()
      },
      deletePromoRequest(id){
         this.currentPromoId = id;
         let mssg = "¿Desea quitar la promoción de su carrito?";
         this.confirmationDialog(this.doDeletePromo, "Confirmar", mssg, "Eliminar");
      },
      doDeletePromo(){
         this.removePromotionDetailForPromo(this.currentPromoId)
         const amounts = this.calculateTotalPromoAmounts(this.promotion_details)
         this.updatePromoAmounts(amounts);
         this.loadDiscountsOrder()
         //this.updateSaleInfo()
      },
      getProductImgUrl(product){
         if(product){
            return Product.getCheckoutImgUrl(product) ?? this.thumbnailUrl;
         }
      },

      setOrderDetailToState(pieces){
         const det = this.setOrderDetail(this.currentProduct, pieces)
         this.addOrUpdateOrderDetail(det);
         const amounts = this.calculateTotalAmounts(this.order_details)
         this.updateAmounts(amounts);
      },

      async onUpdateProduct(pieces){
         this.setOrderDetailToState(pieces)
         this.closeProductPrompt()
         this.loadDiscountsOrder()
         //this.updateSaleInfo()
      },

      openProductPrompt(){
         this.$store.commit("TOGGLE_IS_PRODUCT_PROMPT_POPUP_ACTIVE", true);
      },
      closeProductPrompt(){
         this.$store.commit("TOGGLE_IS_PRODUCT_PROMPT_POPUP_ACTIVE", false);
      },

      async close(){
         this.deletePromptActive = false
      },
      async doAcceptDelete(){

      },
      async getClientInfo(){
         this.showLoader("Obteniendo información ...")
         const res = await this.xget('/client_info/'+this.user.ID);
         if(res.success){
            this.setClientInfo(res.data);
         }
         this.stopLoader()
      },      
      setClientInfo(clientInfo){
         this.clientInfo = Client_Info.fromServiceClienteInfo(clientInfo);
      },      
      async getOrderDiscounts(){
         this.loadDiscountsOrder()         
      },
      loadDiscountsOrder(){
         // Descuento de cliente
         var desc_cliente = parseFloat(this.clientInfo.descuento);
         if (desc_cliente > 0 && !this.clientInfo.negocio_especial){
            this.aplicaDescuentoCliente = true;
            this.descuentoClientePg = desc_cliente * 0.01;
         }

         // Si es negocio especial no aplica descuento de cliente, descuento de cerveza ni descuento por Monto (Por confirmar)
         if(this.clientInfo.negocio_especial){

            // Se obtiene listado de precios especiales
            this.specialPriceProducts = [];
            this.getSpecialPriceProducts.forEach(specialPriceProduct => {
               this.specialPriceProducts.push(SpecialPriceProduct.fromServiceSpecialPriceProduct(specialPriceProduct));
            });
            
            if(this.specialPriceProducts.length > 0){
               // Si hay configurados, se buscan productos que pueden tener precio especial
               this.order_details.forEach(line => {
                  var specialPrice = this.findSpecialPriceByProduct(line.product_id);
                  if (specialPrice != null){
                     // Se asigna precio especial y descuento
                     var actual_cost = line.pieces * line.product.cost
                     var new_special_cost = line.pieces * specialPrice.precio_neto
                     line.cost = new_special_cost
                     line.discount = actual_cost - new_special_cost
                     // Se actualizan valores en state
                     this.addOrUpdateOrderDetail(line);
                  }
               });   
            }         
         }

         // Se valida descuento de cliente y si aplica descuento por cerveza
         if(this.aplicaDescuentoCliente){
            this.order_details.forEach(line => {
               if (line.product.is_beer){
                  var beer_discount = parseFloat(this.getDiscountBeer)
                  var beer_discountPg = 0
                  if (beer_discount > 0){
                     beer_discountPg = beer_discount * 0.01
                  }
                  // Se asigna descuento de cerveza
                  var beer_discount = line.cost * beer_discountPg
                  line.discount = beer_discount
               }else{
                  // Se asigna descuento de cliente
                  var client_discount = line.cost * this.descuentoClientePg
                  line.discount = client_discount
               }
               // Se actualizan valores en state
               this.addOrUpdateOrderDetail(line);
            });   
         }
         // Se actualiza información de orden con descuentos por aplicar
         this.updateSaleInfo();
      }, 
      findSpecialPriceByProduct(product_id){
         var special_price = this.specialPriceProducts.find(f => f.id_producto == product_id)
         return special_price;
      },
      updateSaleInfo(){
         this.updateAmountsOrder();
         this.refreshDiscountsForAmountOrder();
         this.updateResumeOrder();
      },
      updateAmountsOrder(){

         this.totalProductos = 0;
         this.totalDescuentoProductos = 0;
         this.totalPiezasProductos = 0;
         this.totalCajasProductos = 0;

         // Montos de productos sin promoción
         this.order_details.forEach(line => {
            this.totalProductos += line.cost;
            this.totalDescuentoProductos += line.discount;
            // Se convierten piezas de string a number
            this.totalPiezasProductos += parseInt(line.pieces, 10);
            this.totalCajasProductos += line.boxes;
         });

         this.totalProductosPromociones = 0;
         this.totalDescuentoPromos = 0;

         // Montos de productos de promociones
         this.promotion_details.forEach(promo => {
            this.totalProductosPromociones += promo.subtotal;
            this.totalDescuentoPromos += promo.discount;
         });
      },
      refreshDiscountsForAmountOrder(){

         this.totalDescuentosxMonto = 0;

         // En clientes de tipo negocio_especial, no aplican descuentos por monto.
         if(!this.clientInfo.negocio_especial){     

            // Se obtienen descuentos por monto configurados
            this.descuentosPorMonto = [];
            this.getDiscountsbyAmount.forEach(discountAmount => {
               this.descuentosPorMonto.push(Descuento_Monto.fromServiceDescuentoPorMonto(discountAmount));
            });

            // Se define tipo de regla configurada como candidata a aplicar con base a Piezas, Cajas o Importe.
            // Piezas
            this.descuentoMontoAlcanzadoAux = this.descuentosPorMonto.find(f => 
                                 (this.totalPiezasProductos >= f.min_compra && this.totalPiezasProductos <= f.max_compra) && (f.tipo_regla === "Piezas"));
            // Cajas
            if (this.descuentoMontoAlcanzadoAux == null){
                  this.descuentoMontoAlcanzadoAux = this.descuentosPorMonto.find(f => 
                                 (this.totalCajasProductos >= f.min_compra && this.totalCajasProductos <= f.max_compra) && (f.tipo_regla === "Cajas"));
            }
            // Importe
            if (this.descuentoMontoAlcanzadoAux == null){
                  this.descuentoMontoAlcanzadoAux = this.descuentosPorMonto.find(f => 
                                 (this.totalProductos >= f.min_compra && this.totalProductos <= f.max_compra) && (f.tipo_regla === "Importe"));
            }

            // Se omiten productos de segmentos que no aplican y se evalua nuevamente la regla.
            if (this.descuentoMontoAlcanzadoAux != null){
               // Listado de segmentos que no aplican
               this.segmentosNoAplicaList = this.descuentoMontoAlcanzadoAux.segmentos_no_aplica.trim().split(',');

               var TotalPiezas = this.totalPiezasProductos;
               var TotalCajas = this.totalCajasProductos;
               var TotalImporte = this.totalProductos;

               if (this.segmentosNoAplicaList != null){

                  this.order_details.forEach(line => {
                     // Si la categoria del producto es de los segmentos que no aplican se descuenta de los totales para validar nuevamente
                     if (this.segmentosNoAplicaList.indexOf(line.product.category_id) === 0){
                        TotalPiezas    -= parseInt(line.pieces, 10);
                        TotalCajas     -= line.boxes;
                        TotalImporte   -= line.cost;
                     }
                  });
               }

               // Se evaluan nuevamente reglas de descuento por Monto.
               // Piezas
               this.descuentoMontoAlcanzado = this.descuentosPorMonto.find(f => 
                                          (TotalPiezas >= f.min_compra && TotalPiezas <= f.max_compra) && (f.tipo_regla === "Piezas"));
               // Cajas
               if (this.descuentoMontoAlcanzado == null)
               {
                  this.descuentoMontoAlcanzado = this.descuentosPorMonto.find(f => 
                                          (TotalCajas >= f.min_compra && TotalCajas <= f.max_compra) && (f.tipo_regla === "Cajas"));
               }
               // Importe
               if (this.descuentoMontoAlcanzado == null)
               {
                  this.descuentoMontoAlcanzado = this.descuentosPorMonto.find(f => 
                                          (TotalImporte >= f.min_compra && TotalImporte <= f.max_compra) && (f.tipo_regla === "Importe"));
               }

            }

            // Si se encuentra descuento por monto aplicable, se calcula.
            if (this.descuentoMontoAlcanzado != null){

               this.descuentoMontoAlcanzadoPg = parseFloat(this.descuentoMontoAlcanzado.porcentaje) * 0.01;

               // El descuento por monto no se considera si el cliente tiene descuento de cliente y es mayor al descuento por monto alcanzado.
               if (!(this.aplicaDescuentoCliente && this.descuentoClientePg >= this.descuentoMontoAlcanzadoPg)){

                  // Se indica que aplican descuentos por monto
                  this.usandoDescuentoMonto = true;

                  this.order_details.forEach(line => {

                     var descuentoMonto = 0;

                     // En cerveza, no aplica descuento por monto, se usa el descuento por cerveza (en caso de que el cliente tenga descuento)
                     if (line.product.is_beer){
                        descuentoMonto = line.discount
                     }
                     else if (this.segmentosNoAplicaList.indexOf(line.product.category_id) === 0){
                        // Si la categoria del producto es de los segmentos que no aplican, se ignora, y se le asigna el descuento de cliente existente
                        descuentoMonto = line.discount
                     }
                     else{
                        descuentoMonto = line.product.cost * this.descuentoMontoAlcanzadoPg * parseInt(line.pieces, 10);
                     }

                     // Se asigna descuentos
                     line.discountbyAmount = descuentoMonto
                     line.discount = descuentoMonto
                     // Se actualizan valores en state
                     this.addOrUpdateOrderDetail(line);

                     // Acumulado de descuentos por monto
                     this.totalDescuentosxMonto += descuentoMonto;

                  });
               }

            }
         }

         // Se actualizan montos de orden
         const amounts = this.calculateTotalAmounts(this.order_details)
         this.updateAmounts(amounts);
      
      },
      updateResumeOrder(){        
         //this.subtotal = this.amounts.after_tax_total + this.promo_amounts.after_tax_total
         // Subtotal + IEPS
         //this.subtotal = (this.amounts.subtotal + this.amounts.ieps) + (this.promo_amounts.subtotal_order_lines + this.promo_amounts.ieps)
         this.subtotal = this.amounts.subtotal;
         // Importe total de descuentos
         if (this.usandoDescuentoMonto){
               this.totalDescuentosOrden = this.totalDescuentoPromos + this.totalDescuentosxMonto;
         }
         else{
               this.totalDescuentosOrden = this.totalDescuentoPromos + this.totalDescuentoProductos;
         }
         // Importe final a pagar
         this.totalImportePagar = this.amounts.after_tax_total + this.promo_amounts.after_tax_total - this.totalDescuentosOrden;

      }
   },
}
</script>
